var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bookpage flex-column justify-center",style:(`display: none;
    font-size:${
        _vm.bookReadConf ? _vm.bookReadConf.fontSize : ''
    }px !important;font-family:${_vm.mainFont}!important;`),attrs:{"id":`bookpage_${_vm.page_id}`},domProps:{"innerHTML":_vm._s(_vm.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }